<template>
  <Modal title="关系查询"
         v-model="visible"
         width="1200"
         class="my-modal top"
         :mask-closable="false"
         :footer-hide="true">
    <Tabs v-if="visible"
          v-model="searchParams.type"
          @on-click="setData()">
      <TabPane label="推荐关系"
               name="1"></TabPane>
      <TabPane label="管理关系"
               name="2"></TabPane>
      <TabPane label="育成关系"
               name="3"></TabPane>
      <TabPane label="销支关系"
               name="4" v-if="$units.isOkBao() || $units.isOkTX()"></TabPane>
    </Tabs>
    <div class="table-box">
      <loading :isShow="listLoading" />
      <Table class="table1"
             ref="table"
             @on-expand-tree="dealWidth"
             :columns="columns"
             :data="tableData"
             row-key="id"
             :indent-size="30">
        <template slot-scope="{ row }"
                  slot="name">
          <span :class="!row._showChildren ? 'isLast' : ''">
            <span :class="row.isSelf == 1 ? 'self' : ''">
              {{ row.staffNo ? row.staffNo + '-' + row.name : row.name }}</span>
          </span>
        </template>
      </Table>
    </div>

  </Modal>
</template>

<script>
  import { pageTool } from '@/api/mixins';
  export default {
    mixins: [pageTool],
    components: {},
    props: {},
    data() {
      return {
        visible: false,
        tableData: [],
        listLoading: false,
        selfIdx: null,
        searchParams: {
          userId: '',
          type: '1' //1-推荐关系 2-管理关系 3-育成关系
        },
        //表单搜索字段
        columns: [
          // {
          //   title: "序号",
          //   type: "index",
          //   width: 70,
          //   align: "center",
          // },
          {
            title: '业务员',
            slot: 'name',
            align: 'left',
            minWidth: 220,
            // minWidth: 120,
            // fixed:'left',
            width: 1000,
            tree: true
          },
          {
            title: '所属机构/团队',
            key: 'orgName',
            minWidth: 240,
            fixed: 'right',
            align: 'center',
            render(h, params) {
              return (
                <span>
                  {params.row.orgName || '-'}/{params.row.groupName || '-'}
                </span>
              );
            }
          },
          {
            title: '职级',
            key: 'rankName',
            align: 'center',
            fixed: 'right',
            minWidth: 200,
            tooltip: true
          }
        ]
      };
    },
    methods: {
      setColumn(width) {
        this.columns = [
          {
            title: '业务员',
            slot: 'name',
            align: 'left',
            minWidth: 220,
            width,
            tree: true
          },
          {
            title: '所属机构/团队',
            key: 'orgName',
            minWidth: 240,
            fixed: 'right',
            align: 'center',
            render(h, params) {
              return (
                <span>
                  {params.row.orgName || '-'}/{params.row.groupName || '-'}
                </span>
              );
            }
          },
          {
            title: '职级',
            key: 'rankName',
            align: 'center',
            fixed: 'right',
            minWidth: 200,
            tooltip: true
          }
        ];
      },
      setData() {
        this.listLoading = true;
        this.$http({
          url: '/buz/userBase/queryRelation',
          type: 'GET',
          data: this.searchParams
        })
          .then(res => {
            this.listLoading = false;
            this.selfIdx = null;
            this.tableData = this.dealTree(res.data,res.data && res.data[0].isSelf == 1);
            setTimeout(() => {
              this.dealWidth();
            }, 100);
          })
          .catch(e => {
            this.listLoading = false;
          });
      },
      dealWidth() {
        let _this = this;
        setTimeout(() => {
          let list = [];
          const dom = document.getElementsByClassName('table1')[0].getElementsByClassName('ivu-table-column-left');
          dom.forEach(item => {
            if (item.className.indexOf('ivu-table-hidden') == -1 && item.parentElement.style.display != 'none') {
              list.push(item);
            }
          });
          let widthArr = [];
          list.forEach((item, index) => {
            if (index != 0) {
              item.children[0].children.forEach(child => {
                if (widthArr[index]) {
                  widthArr[index] += child.offsetWidth;
                } else {
                  widthArr[index] = child.offsetWidth;
                }
              });
            }
          });
          widthArr.shift();
          let maxNum = Math.max(...widthArr);
          document
            .getElementsByClassName('table1')[0]
            .getElementsByTagName('table')
            .forEach(item => {
              // item.style.width = width + 700 + 'px';
              _this.setColumn(maxNum + 200 < 698 ? 698 : maxNum + 200);
            });
        }, 500);
      },
      dealTree(arr,topSelf) {
        return arr.map((item, idx) => {
          if (item.isSelf == 1) {
            this.selfIdx =  idx;
          }
          return {
            ...item,
            _showChildren:topSelf || this.selfIdx == null || item.isSelf == 1,
            children: item.children && item.children.length > 0 ? this.dealTree(item.children,topSelf) : []
          };
        });
      },
      open(data) {
        this.selfIdx = null;
        this.visible = true;
        this.searchParams.userId = data.userId;
        this.searchParams.type = '1';
        this.setData();
      }
    }
  };
</script>
<style lang="scss" scoped>
/deep/.ivu-table-cell-slot {
  display: initial;
}

// /deep/.ivu-table-column-left {
//   .ivu-table-cell {
//     overflow: auto;
//     text-overflow: unset;
//     white-space: nowrap;
//   }
// }

.self {
  color: #236dff;
}

.dian {
  display: block;
  width: 5px;
  height: 5px;
  background: #35bf3f;
  border-radius: 50%;
  margin-right: 4px;

  &.red {
    background: #e3461f;
  }
}
</style>
